// extracted by mini-css-extract-plugin
module.exports = {"color_primario_uno":"#84bd00","color_primario_dos":"#1F8252","color_primario_tres":"#CBDC0D"};